// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner{background-repeat:no-repeat;background-size:cover;color:#fff;padding:40px 0;position:relative}@media (max-width:600px){.banner{height:auto!important;text-align:center}.banner p{font-size:14px}.text-h6{font-size:16px!important}.custom-slide{box-sizing:border-box!important;padding:0 12px!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
